import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import { useAppStore } from 'Store/app'

export const useBotIconStore = defineStore('BotIcon', () => {
  const appStore = useAppStore()
  const bottom = ref(10)
  const right = ref(10)
  const iconSizeMobile = ref(80)
  const iconSizePC = ref(80)
  const iconSize = computed(() => (appStore.isFullScreen ? iconSizeMobile.value : iconSizePC.value))

  function updateIconSize({ mobile, pc }) {
    iconSizeMobile.value = mobile || 80
    iconSizePC.value = pc || 80
  }

  function setBotIconBottom(value) {
    bottom.value = value
  }

  function setBotIconRight(value) {
    right.value = value
  }

  return {
    bottom,
    right,
    iconSizeMobile,
    iconSizePC,
    iconSize,
    updateIconSize,
    setBotIconBottom,
    setBotIconRight
  }
})
